import { createApi } from '@reduxjs/toolkit/query/react';

import {
  getBaseUrlObNextGen,
  getObNextGenApiUrlLists,
} from '../../../constants/obNextGenConstants';
import { axiosBaseQuery } from '../../../services/baseQuery';
import { type IntegrationAPIResponse } from '../data-layer/types';

export const integrationAllTabApi = createApi({
  reducerPath: 'integrationAllTabApi',
  baseQuery: axiosBaseQuery({ baseUrl: getBaseUrlObNextGen() }),
  endpoints: (builder) => ({
    getAllTabIntegrations: builder.query<
      IntegrationAPIResponse,
      {
        page: number;
        showHiddenApps: boolean;
        searchQuery: string;
        selectedTypes: string;
      }
    >({
      query: ({ page, showHiddenApps, searchQuery, selectedTypes }) => {
        const params = new URLSearchParams();

        params.append('page', String(page));

        if (showHiddenApps) {
          params.append('hidden', 'true');
        }

        if (searchQuery.trim()) {
          params.append('search', searchQuery.trim());
        }

        if (selectedTypes) {
          params.append('types', selectedTypes);
        }

        return {
          url: `${
            getObNextGenApiUrlLists().INTEGRATION_ALL_TAB
          }?${params.toString()}`,
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetAllTabIntegrationsQuery } = integrationAllTabApi;
